'use strict';
import util from '../util';


let $body = $('body');

var completePhoneNumber = function () {
    const countrySelect = $('select[id$="_country"]');
    $('#modal-custom-placeholder, .checkout-shipping-content, .account-side-panel').on('selectmenuchange change', countrySelect, function() { 
        try {
            if($body.hasClass('checkout_page') && (typeof gtCurPage != undefined && gtCurPage == 'coshipping-start')){    
                util.prePopulateCallingCountryCodeEle($(this).val(),this);
            } else {
                util.prePopulateCallingCountryCode($(this).val());
            }
        } catch (error) {
            console.error('Error in pre-populating calling country code:', error);
        }
    });
};

const updatePlaceholderValue = () => {
    $('#modal-custom-placeholder, .checkout-shipping-content, .account-side-panel').on('selectmenuchange change', 'select[id$="_country"]', function() {
        const $this = $(this);
        const countryValue = $this.val();
        const optionFlagValue = 'flag-'+countryValue.toLowerCase();
        const $selectedOption = $this.find(`.${optionFlagValue}`);
        const placeholderCity = $selectedOption.attr('data-placeholder');
        const placeholderPhone = $selectedOption.attr('data-phone');
        const placeholderPostal = $selectedOption.attr('data-postal');
        const $fieldset = $this.closest('fieldset');
        // Update placeholders with the changed country
        $fieldset.find('.input-text.city').attr('placeholder', placeholderCity);
        $fieldset.find('.input-text.phonenumber').attr('placeholder', placeholderPhone);
        $fieldset.find('.input-text.postal').attr('placeholder', placeholderPostal);
    });
};

var updatePlaceholderValueOnLoad = function () {
    const $countrySelect = $('select[id$="_country"]');
    let countryValue, $optionFlagValue, placeholderCity, placeholderPhone, placeholderPostal, $fieldset;
    if ($countrySelect.length) {
        countryValue = $countrySelect.val();
        $optionFlagValue = $('.input-select.country').find('.flag-' + countryValue.toLowerCase());
        placeholderCity = $optionFlagValue.attr('data-placeholder');
        placeholderPhone = $optionFlagValue.attr('data-phone');
        placeholderPostal = $optionFlagValue.attr('data-postal');
        $fieldset = $countrySelect.closest('fieldset');

        // Update placeholders
        $fieldset.find('.input-text.city').attr('placeholder', placeholderCity);
        $fieldset.find('.input-text.phonenumber').attr('placeholder', placeholderPhone);
        $fieldset.find('.input-text.postal').attr('placeholder', placeholderPostal);
    }
}

var phoneFieldError = function () {
    $('input[id$="_areaCode"]').focus(function() {        
        $(this).on('blur', function(e) {
            $('input[id$="_phoneNumber"]').blur();        
        });        
    });
}

var showDefaultCode = function () {
    const countrySelect = $('select[id$="_country"]');
    var code = countrySelect.val();
    util.prePopulateCallingCountryCode(code);
}

const showLastname2 = () => {
    $('#modal-custom-placeholder, .checkout-shipping-content, .account-side-panel').on('selectmenuchange change', 'select[id$="_country"]', function() {
        const $formRow = $(this).closest('form').find('.form-row');
        const isSpain = $(this).val() === 'ES';

        if ($formRow.filter('.lastname2').length) {
            const $firstnameRow = $formRow.filter('.firstname');
            const $lastnameRow = $formRow.filter('.lastname');
            const $lastname2Row = $formRow.filter('.lastname2');

            $lastname2Row.toggleClass('hidden', !isSpain);
            $firstnameRow.add($lastnameRow).toggleClass('no-lastname2', isSpain);
            $firstnameRow.toggleClass('full-width', isSpain).toggleClass('split half-width', !isSpain);
            $lastnameRow.toggleClass('left', isSpain).toggleClass('right', !isSpain);
        }
    });
};

var populatePhoneFields = function (phone) {
    const countrySelect = $('select[id$="_country"]');
    var selectedCountryCode = countrySelect.data('country');
    if (selectedCountryCode) {
        const areaCode = util.getCallingCountryCode(selectedCountryCode.toLowerCase());
        if (areaCode && phone) {
            const phoneNumberPrefix = util.getCallingPhoneNumPrefix(selectedCountryCode);
            const phonenumber = util.removeAreaCode(phone, areaCode);
            $('input[id$="_areaCode"]').val(areaCode);
            if(phoneNumberPrefix != undefined){
                $('input[id$="_phoneNumber"]').val(phoneNumberPrefix+''+phonenumber);
            } else {
                $('input[id$="_phoneNumber"]').val(phonenumber);
            }
        }
        countrySelect.val(selectedCountryCode).trigger('change');
    }  
}

var getEditAddressFormPhoneNum = function() {
    if($('#dwfrm_shippingaddress_areaCode').length === 0 && $('#dwfrm_shippingaddress_phoneNumber').length === 0) { 
        return; 
    }
    $('#modal-custom-placeholder, .checkout-shipping-content, .account-side-panel').on('focusout','input[class~="phonenumber"]', function() {
        var customFoneNumber = $('#dwfrm_shippingaddress_phoneNumber').val();
        var selectedCountryCode = $('#dwfrm_shippingaddress_country').val();
        if(customFoneNumber !== 'null' && selectedCountryCode !== 'null'){
            var custFoneNumb = util.getFormattedPhoneNumber(customFoneNumber,selectedCountryCode);
            $('#dwfrm_shippingaddress_phone').val(custFoneNumb);        
        }
    });
}

var newAddressForm = {
    init: function() {
        completePhoneNumber();
        showDefaultCode();
        phoneFieldError();
        showLastname2();
        updatePlaceholderValue();
        util.getPhoneNumWithCode();
        getEditAddressFormPhoneNum();
        updatePlaceholderValueOnLoad();
    },
    populatePhoneFields: populatePhoneFields,
    updatePlaceholderValue: updatePlaceholderValue
};

export default newAddressForm;